export default "__VITE_ASSET__DOgpdW$C__"